import * as React from "react";
import Typography from "@mui/material/Typography";
import { CommonProps } from "@mui/material/OverridableComponent";

interface TitleProps {
  children?: React.ReactNode;
  component?: React.ElementType;
  text: string;
}

export const TitleGroup = (props: TitleProps & CommonProps) => {
  return (
    <Typography
      {...props}
      gutterBottom
      component={"h3"}
      style={{
        fontWeight: "bold",
        fontSize: "1.3rem",
        ...props.style
      }}
    >
      {props.text}
    </Typography>
  );
};
